// kitchen/web/src/hooks/useClientConfig.ts
// Fetches the client KDS configuration (kdsBoardConfig) from the backend.
// Provides a DEFAULT_KDS_BOARD_CONFIG fallback when data is not yet available.

import { useQuery } from "@tanstack/react-query";
import { clientConfigApi, type ClientConfig } from "../api/client";
import {
  DEFAULT_KDS_BOARD_CONFIG,
  type KdsBoardConfig,
} from "../lib/table-board";

export function useClientConfig(clientId: string | null): {
  config: KdsBoardConfig;
  clientConfig: ClientConfig | undefined;
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery<ClientConfig>({
    queryKey: ["kitchen-client-config", clientId],
    queryFn: () => clientConfigApi.get(clientId!),
    enabled: !!clientId,
    staleTime: 60_000,
  });

  const config: KdsBoardConfig =
    data?.kdsBoardConfig ?? DEFAULT_KDS_BOARD_CONFIG;

  return { config, clientConfig: data, isLoading };
}
